<script>
import { Bar } from 'vue-chartjs'
import _ from 'lodash'

export default {
  extends: Bar,
  name: "network-analysis-service-range-chart",

  props: [ 'series', 'series2' ],

  watch: {
    series: function() {
      this.render()
    }
  },

  computed: {
    histogramBins() {
      return this.series.bins.map(o => { return o.name })
    },
    dataSeries() {
      return _.map(this.series.bins, o => { return o.serviceRangeValue || 0 })
    },
    dataSeries2() {
      return _.map(this.series2.bins, o => { return o.serviceRangeValue || 0 })
    },
    dataSets() {
      let sets = [{
        backgroundColor: [ '#88b4e0', '#88b4e0', '#88b4e0', '#88b4e0', '#88b4e0' ],
        data: this.dataSeries2.length > 0 ? this.dataSeries2 : this.dataSeries,
        label: 'Actual'
      }]
      if(this.dataSeries2.length > 0) {
        sets.push({
          backgroundColor: [ '#FABF00', '#FABF00', '#FABF00', '#FABF00', '#FABF00' ],
          data: this.dataSeries,
          label: 'What-If'
        })  
      }

    return sets
    }
  },

  methods: {
    render() {
      this.renderChart({
        labels: this.histogramBins,
        datasets: this.dataSets
        }, {
          legend: {
            display: false,
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem) {
                return Number(tooltipItem.yLabel).toFixed(0).replace(/./g, function(c, i, a) {
                    return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c
                }) + "%"
              }
            }
          },
          maintainAspectRatio: false,
          animation: {
              onComplete: function() {
                var ctx = this.chart.ctx;
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                var chart = this;
                var datasets = this.config.data.datasets;

                datasets.forEach(function (dataset, i) {
                  if(i > 0) {
                    ctx.font = "60% Roboto";
                    ctx.fillStyle = "#222"
                    chart.getDatasetMeta(i).data.forEach(function (p, j) {
                      let deltaPercent = (datasets[i].data[j] - datasets[i-1].data[j]).toFixed(2)
                      let label = isNaN(deltaPercent) ? '' : `${deltaPercent}%`
                      ctx.fillText(label, p._model.x, p._model.y + -5);
                    })
                  }
                })
              },          
          },
          scales: {
            yAxes: [{
              stacked: false,
              ticks: {
                userCallback: function(value) {
                  value = value.toString();
                  value = value.split(/(?=(?:...)*$)/);
                  value = value.join(',');
                  return `${value}%`
                }
              },
              scaleLabel: {
                display: true,
                labelString: 'Percent of Population',
                fontColor: '#999'
              }
            }],
            xAxes: [{
              stacked: false,
              scaleLabel: {
                display: true,
                labelString: 'Driving Time (8.5 hour day)',
                fontColor: '#999'
              }
            }]
          }
        }
      )
    }
  },

  mounted () {
    this.render()
  }
}

</script>